import P from 'bluebird';

window.Promise = P;
// eslint-disable-next-line no-underscore-dangle, no-undef
window._LTracker = [];
// eslint-disable-next-line no-underscore-dangle
window._LTracker.push({
  logglyKey: 'd95daaf3-a943-48f4-8687-cd0c6696f50b',
  sendConsoleErrors: false,
  tag: 'fc-app-browser-logger'
});
// window.Promise.longStackTraces();



// WEBPACK FOOTER //
// ./src/client/utils/global_util.js